import { render, staticRenderFns } from "./NAO_Categorias.vue?vue&type=template&id=872578ba&scoped=true&"
import script from "./NAO_Categorias.vue?vue&type=script&lang=js&"
export * from "./NAO_Categorias.vue?vue&type=script&lang=js&"
import style0 from "./NAO_Categorias.vue?vue&type=style&index=0&id=872578ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872578ba",
  null
  
)

export default component.exports